/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav P�ibyl (pribyl@cadwork.cz)
 *
 */

import RenderOption from "App/render/webgl/renderables/render_option";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import Pass from "App/render/webgl/passes/pass";
import WebGLContext from "App/web_gl_context";
import Factory from "App/render/webgl/renderables/factory";
import IScene from "js_interface/src/scene_interface";

export default
class LineRenderOption extends RenderOption {

    public static TypeName: string = "LineParams";

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph) {
        super(aSceneAPI, aRenderGraph);

        // default values
        this._props = null;
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph): LineRenderOption {
        return new LineRenderOption(aSceneAPI, aRenderGraph);
    }

    public render(aRenderPass: Pass) {
        let shader: any = aRenderPass.getActiveShaderRenderable();
        let gl = (<WebGLContext>this._context).getWebGLRenderingContext();

        super.render(aRenderPass);

        gl.uniform1f(shader.uniformLocations.u_line_width, this._props.linewidthScaleFactor);
        gl.uniform1i(shader.uniformLocations.u_line_type, this._props.linetype);
    }
}

Factory.register(LineRenderOption);
